// What the counter may show about the visit in front of it.
//
// Only what the organisation declared for the counter surface: a value typed for
// the slip is the customer's, and a clerk seeing it because it happened to be on
// the ticket is exactly the leak declarations exist to prevent.
import type { VisitField } from './types'
import { resolveText } from './i18n/customer'

export interface CounterFact { key: string; label: string; value: string }

export function counterFacts(
  declared: readonly VisitField[],
  values: Record<string, string> | undefined,
  lang: string,
): CounterFact[] {
  if (!values) return []
  return declared
    .filter((f) => f.active && f.surfaces.includes('counter'))
    .filter((f) => (values[f.key] ?? '').trim() !== '')
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((f) => ({ key: f.key, label: resolveText(f.name, lang) || f.key, value: values[f.key]! }))
}
